var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.fieldsLoading
        ? _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            _vm._l(9, function (n) {
              return _c(
                "v-col",
                { key: n, attrs: { cols: "12", sm: "6", lg: "3" } },
                [
                  _c(
                    "v-sheet",
                    { staticClass: "mt-2" },
                    [
                      _c("v-skeleton-loader", {
                        staticClass: "mx-auto",
                        attrs: { type: "list-item" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : [
            _c(
              "v-row",
              { staticClass: "mt-3 mb-2 mx-0" },
              [
                _c(
                  "v-col",
                  { staticClass: "pa-0 pl-1 pt-1", attrs: { cols: "12" } },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        outlined: "",
                        dense: "",
                        label: _vm.$t("message.projects.project"),
                        items: _vm.listOfProjects,
                        "hide-details": "",
                        "item-text": "projectName",
                        "item-value": "id",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$router.push({
                            name: "project_action",
                            params: { project_id: $event },
                          })
                        },
                      },
                      model: {
                        value: _vm.activeProjectId,
                        callback: function ($$v) {
                          _vm.activeProjectId = $$v
                        },
                        expression: "activeProjectId",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-row",
              { staticClass: "mb-2 mx-0" },
              [
                _c("form-data", {
                  ref: "projectFormRef",
                  attrs: {
                    references: _vm.formReferences,
                    model: _vm.projectFormModel,
                  },
                  on: {
                    "update:references": function ($event) {
                      _vm.formReferences = $event
                    },
                  },
                }),
              ],
              1
            ),
            [
              _c(
                "v-row",
                _vm._l(_vm.speedDialItems, function (item, index) {
                  return _c(
                    "v-col",
                    {
                      key: index,
                      staticClass: "pa-1",
                      attrs: {
                        cols: "6",
                        lg: "2",
                        md: "3",
                        sm: "4",
                        xl: "2",
                        xs: "2",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          key: index,
                          attrs: {
                            to: item.to,
                            outlined: "",
                            rounded: "lg",
                            border: "",
                            variant: "outlined",
                            color: _vm.$listSurface,
                          },
                        },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "text-center" },
                            [
                              item.type === "link"
                                ? [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: item.link,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                  ]
                                : [_vm._v(_vm._s(item.name))],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
          ],
      _vm.projectFeaturePwa.project_chat
        ? _c(
            "v-btn",
            {
              staticClass: "pcc-fab",
              attrs: {
                color: "primary",
                fab: "",
                dark: "",
                title: _vm.$t("message.projects.chat"),
                "aria-label": _vm.$t("message.projects.chat"),
              },
              on: { click: _vm.openChat },
            },
            [
              _vm.chatUnread
                ? _c(
                    "v-badge",
                    {
                      attrs: {
                        color: "error",
                        content: _vm.chatUnread,
                        overlap: "",
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-message-text")])],
                    1
                  )
                : _c("v-icon", [_vm._v("mdi-message-text")]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "900",
            scrollable: "",
            fullscreen: _vm.$vuetify.breakpoint.smAndDown,
            transition: "dialog-bottom-transition",
          },
          model: {
            value: _vm.chatDialog,
            callback: function ($$v) {
              _vm.chatDialog = $$v
            },
            expression: "chatDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pcc-dialog-card" },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "flex-grow-0",
                  attrs: { dense: "", flat: "", dark: "", color: "primary" },
                },
                [
                  _c("v-icon", { staticClass: "mr-2", attrs: { small: "" } }, [
                    _vm._v("mdi-message-text"),
                  ]),
                  _c("v-toolbar-title", { staticClass: "subtitle-2" }, [
                    _vm._v(_vm._s(_vm.$t("message.projects.chat"))),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeChat },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-0 pcc-dialog-body" },
                [
                  _vm.chatDialog
                    ? _c("project-chat", {
                        attrs: { project: _vm.activeProjectId, embedded: "" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }